import { motion } from "framer-motion";
import { Phone, Radio } from "lucide-react";
import { CONTACTS } from "@/data/site";

export default function EmergencyBar() {
  return (
    <section className="relative bg-surface border-y border-steel" data-testid="emergency-dispatch-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-5 flex items-center gap-4"
        >
          <span className="relative flex h-4 w-4">
            <span className="animate-ping absolute inline-flex h-full w-full bg-racing opacity-60" />
            <span className="relative inline-flex h-4 w-4 bg-racing" />
          </span>
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-racing font-bold flex items-center gap-2">
              <Radio className="w-3.5 h-3.5" /> Dispatch Active Now
            </p>
            <p className="font-heading font-extrabold uppercase text-2xl text-white mt-1">
              Rig down? We roll 24/7.
            </p>
          </div>
        </motion.div>

        {[
          { c: CONTACTS.omar, testid: "emergency-bar-call-omar", primary: true },
          { c: CONTACTS.ray, testid: "emergency-bar-call-ray", primary: false },
        ].map(({ c, testid, primary }, i) => (
          <motion.a
            key={testid}
            href={c.tel}
            data-testid={testid}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.15 + i * 0.12 }}
            className={`lg:col-span-3 xl:col-span-3 group flex items-center justify-between gap-3 px-6 py-4 border transition-all duration-300 ${
              primary
                ? "bg-racing border-racing text-white hover:bg-[#E01F1F]"
                : "border-hazard/50 text-hazard hover:bg-hazard hover:text-carbon"
            }`}
          >
            <span>
              <span className="block font-mono text-[10px] uppercase tracking-widest opacity-80">{c.name} — {c.role}</span>
              <span className="block font-heading font-black uppercase text-xl">{c.phone}</span>
            </span>
            <Phone className="w-5 h-5 group-hover:rotate-12 transition-transform duration-300" />
          </motion.a>
        ))}
      </div>
    </section>
  );
}
